'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import './util/initializeImmer';
import 'I18n/classicLoader';
import { render } from 'react-dom';
import I18n from 'I18n';
import history from './util/History';
import Favicon from './components/Favicon';
import DocumentHead from './components/portals/DocumentHead'; // Configure the router

import { Router } from 'react-router-dom';
import Routes from './lib/routes'; //Redux

import { Provider } from 'react-redux';
import configureStore from './util/configureStore';
import { TreatmentProvider } from './hooks/useTreatments';
import { ThemeProvider } from './theming/ThemeProvider.js';

var App = /*#__PURE__*/function () {
  function App() {
    _classCallCheck(this, App);
  }

  _createClass(App, [{
    key: "start",
    // Kicks off the app. This is intentionally not in the constructor.
    value: function start() {
      var _this = this;

      var storeReady = this.startRedux();
      Promise.all([I18n.Info, storeReady]).then(function () {
        _this.startRouter();
      }).done();
    }
  }, {
    key: "startRedux",
    value: function startRedux() {
      this.store = configureStore();
    }
  }, {
    key: "startRouter",
    value: function startRouter() {
      render( /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(TreatmentProvider, {
          children: /*#__PURE__*/_jsxs(Router, {
            history: history,
            children: [/*#__PURE__*/_jsx(DocumentHead, {
              children: /*#__PURE__*/_jsx(Favicon, {})
            }), /*#__PURE__*/_jsx(ThemeProvider, {
              children: /*#__PURE__*/_jsx(Routes, {})
            })]
          })
        })
      }), document.getElementsByClassName('page')[0]);
    }
  }]);

  return App;
}();

export { App as default };
new App().start();